import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import { Checkbox, FormControlLabel, FormGroup, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { AbsColor } from '../../constants';
import { IVessel } from '../../contracts/vessel.contract';
import { RegulationAction } from '../../features/regulation.feature';
import { VesselFetch } from '../../features/vessel.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { Loading } from '../shared';

const VesselItem = ({ vessel, index }: { vessel: IVessel; index: number }) => {
    const dispatch = useAppDispatch();
    const classNumbers = useAppSelector((state) => state.Regulation.ByVessel.Filters.ClassNumbers);
    const isChecked = classNumbers.includes(vessel.ClassNumber);

    const handleClick = () => {
        if (isChecked) dispatch(RegulationAction.ByVesselRemoveFilterClassNumber(vessel.ClassNumber));
        else dispatch(RegulationAction.ByVesselAddFilterClassNumber(vessel.ClassNumber));
    };

    return (
        <FormControlLabel
            style={{ width: '100%', backgroundColor: index % 2 === 0 ? AbsColor.White1 : AbsColor.Gray1, marginTop: '4px', marginBottom: '4px' }}
            checked={true}
            control={<Checkbox checked={isChecked} onChange={() => handleClick()} />}
            label={
                <>
                    <Typography style={{ color: AbsColor.Blue1, fontWeight: 'bold' }}>{vessel.VesselName}</Typography>
                    <Typography variant="subtitle2" display={'block'}>
                        {vessel.VesselType}
                    </Typography>
                </>
            }
        />
    );
};

const VesselCriteriaFilter = () => {
    const dispatch = useAppDispatch();
    const vessels = useAppSelector((state) => state.Vessel.List.Vessels);
    const isLoading = useAppSelector((state) => state.Vessel.List.IsLoading);

    useEffect(() => {
        if (!vessels || vessels.length === 0) dispatch(VesselFetch.GetAll());
    }, [dispatch]);

    const CriteriaFilterStyle = {
        IconStyle: {
            color: AbsColor.White1
        },
        MenuStyle: {
            backgroundColor: AbsColor.Blue1,
            color: AbsColor.White1
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <Stack direction={'column'} style={{ width: '100%' }}>
                    <ListItemButton style={{ ...CriteriaFilterStyle.MenuStyle }}>
                        <ListItemIcon>
                            <DirectionsBoatIcon style={{ ...CriteriaFilterStyle.IconStyle }} />
                        </ListItemIcon>
                        <ListItemText primary="My Vessels" />
                    </ListItemButton>
                    <FormGroup style={{ gap: 0 }}>
                        <Stack direction={'column'} gap={0} alignItems={'flex-start'} justifyItems={'flex-start'} alignContent={'flex-start'} style={{ marginLeft: '10px' }}>
                            {vessels?.map((vessel, index) => {
                                return <VesselItem key={vessel.ClassNumber} vessel={vessel} index={index} />;
                            })}
                        </Stack>
                    </FormGroup>
                </Stack>
            )}
        </>
    );
};

export default VesselCriteriaFilter;
